import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export var FormError = function (_a) {
    var errorMessage = _a.errorMessage;
    return _jsx("div", { children: errorMessage });
};
